var map = {
	"./1.gif": 16,
	"./10.gif": 17,
	"./2.gif": 18,
	"./3.gif": 19,
	"./4.gif": 20,
	"./5.gif": 21,
	"./6.gif": 22,
	"./7.gif": 23,
	"./8.gif": 24,
	"./9.gif": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;